import { safeSteps, safetyTips } from "@/mocks/guide";

export default function GuideSteps() {
  return (
    <>
      <section id="steps" className="bg-background-50 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-2xl mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">安全投稿的四个步骤</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              整个流程并不复杂，但每一步都值得慢一点。你保护自己的方式越简单直接，信息被安全处理的可能就越高。
            </p>
          </div>

          <ol className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {safeSteps.map((item, index) => (
              <li
                key={item.title}
                className="bg-background-100 border border-background-200 rounded-lg p-6 flex gap-5"
              >
                <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-semibold">
                  {index + 1}
                </span>
                <div>
                  <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section id="tips" className="bg-primary-950 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            <div className="lg:col-span-4">
              <p className="text-xs tracking-[0.25em] uppercase text-accent-300 mb-3">自我保护</p>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 leading-tight">
                保护身份的建议清单
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-200">
                这些做法看起来琐碎，但正是细节的组合最容易暴露来源。逐条对照一遍，会安心很多。
              </p>
            </div>
            <div className="lg:col-span-8">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {safetyTips.map((tip) => (
                  <li
                    key={tip}
                    className="flex items-start gap-3 bg-primary-900/70 border border-primary-800 rounded-lg p-5"
                  >
                    <i className="ri-shield-check-line text-accent-400 mt-0.5" aria-hidden="true"></i>
                    <span className="text-sm leading-relaxed text-background-100">{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}